var ROOT = "https://www.everlywell.com";
export var shopCategories = {
  "Nutritional Health": "".concat(ROOT, "/products/?category=13"),
  "Vitamins & Supplements": "".concat(ROOT, "/products/?category=11"),
  "General Wellness": "".concat(ROOT, "/products/?category=3"),
  "Sexual Health": "".concat(ROOT, "/products/?category=8"),
  "Women's Health": "".concat(ROOT, "/products/?category=6"),
  "Men's Health": "".concat(ROOT, "/products/?category=5"),
  "Gift Cards": "".concat(ROOT, "/gift-cards/")
};
export var aboutCategories = {
  "The Science": "".concat(ROOT, "/science/"),
  Articles: "".concat(ROOT, "/blog/"),
  Reviews: "".concat(ROOT, "/everlywell-reviews/")
};
export var moreCategories = {
  FAQs: "https://support.everlywell.com/?_ga=2.81793876.337496328.1594735053-1974298.1587144419",
  Help: "https://support.everlywell.com/category/502-contact-us?_ga=2.81793876.337496328.1594735053-1974298.1587144419",
  Careers: "".concat(ROOT, "/careers/"),
  Press: "".concat(ROOT, "/media/"),
  "Become an Affiliate": "https://signup.cj.com/member/signup/publisher/?cid=4993785#/branded?_k=a4hbvp",
  "Refer a Friend": "https://refer.everlywell.com/global-footer/"
};
export var legalLinks = {
  "Accessibility Statement": "".concat(ROOT, "/accessibility"),
  "Privacy Notice": "".concat(ROOT, "/privacy-policy/"),
  "Terms of Use": "".concat(ROOT, "/terms-of-use/")
};
export var socialLinks = {
  Facebook: "https://facebook.com/everlywell/",
  Instagram: "https://instagram.com/everlywell/",
  Twitter: "https://twitter.com/everly_well/",
  LinkedIn: "https://linkedin.com/company/everlywell/"
};